export interface Testimonial {
  id: string;
  name: string;
  role: string;
  quote: string;
  image: string;
  imageAlt: string;
  consent: boolean;
  /** Captura real de la conversación como prueba de autenticidad. */
  proofImage?: string;
  proofAlt?: string;
}

export interface ClientLogo {
  id: string;
  name: string;
  logo: string;
}

export interface WorkSample {
  id: string;
  image: string;
  alt: string;
  caption: string;
}

/**
 * Reseñas reales de clientas. `consent` es la autorización expresa de publicar
 * (respaldo: capturas en `.context/.../fuentes/`). Vive como dato y no en el
 * componente para que lo único que decida publicar sea este filtro.
 */
export const TESTIMONIALS: Testimonial[] = [
  {
    id: "stephanie-chang",
    name: "Stephanie Chang",
    role: "Coach · Libertad con Steph",
    quote:
      "Trabajar con Viviana no solo se trató de tener un buen producto al final (el cual quedó hermosísimo y superó mis expectativas), se trató del proceso. Un proceso que no se encuentra muy fácil con otros proveedores; de escucha, de atención, de buena energía, de ir más allá con los detalles. Siempre la recomiendo con los ojos cerrados.",
    image: "/testimonials/libertad-con-steph.png",
    imageAlt: "Logo de Libertad con Steph, marca de Stephanie Chang",
    consent: true,
    proofImage: "/testimonials/proof/stephanie-chang.png",
    proofAlt: "Captura de la reseña de Stephanie Chang por WhatsApp",
  },
  {
    id: "eileen-diaz",
    name: "Eileen Díaz",
    role: "Psicóloga · +Psicología XFavor",
    quote:
      "Los servicios y productos de Viviconamoryarte son lo mejor que me ha pasado en este último año de vida… Viviana me ayudó a lograr unos de mis más grandes sueños: diseñar e imprimir mi libreta terapéutica. Y como si fuera poco, luego tengo su planner, que ha sido maravilloso para organizar mis proyectos, para pasar de la idea a la acción, con orden, con estructura y sobre todo con claridad.",
    image: "/testimonials/psicologia-xfavor.png",
    imageAlt: "Logo de +Psicología XFavor, consultorio de Eileen Díaz",
    consent: true,
    proofImage: "/testimonials/proof/eileen-diaz.png",
    proofAlt: "Captura de la reseña de Eileen Díaz por WhatsApp",
  },
  {
    id: "eilin-cardona",
    name: "Eilin Cardona",
    role: "Corporativo · Contabilidad y Finanzas",
    quote:
      "He tenido el privilegio de trabajar con Viviana en tres proyectos muy distintos, y en todos superó mis expectativas… Le encargué una agenda corporativa para mi equipo del Departamento de Contabilidad y Finanzas, y la personalizó por completo a mi gusto. El logo de la empresa y la calidad de impresión quedaron espectaculares.",
    image: "/testimonials/eilin-cardona.png",
    imageAlt: "Foto de Eilin Cardona",
    consent: true,
    proofImage: "/testimonials/proof/eilin-cardona.png",
    proofAlt: "Captura de la reseña de Eilin Cardona por WhatsApp",
  },
  {
    id: "gisell-lenascharm",
    name: "Gisell",
    role: "Diseñadora · Lena's Charm",
    quote:
      "Con los planners de Vivi con Amor y Arte encontré una herramienta que de verdad me ha ayudado muchísimo a organizarme, especialmente con todo lo que implica llevar un negocio… Lo que realmente me encanta es que no solo son productos súper lindos, sino que son cosas que realmente uso. Se nota muchísimo el cariño, la dedicación y el cuidado que hay detrás de cada producto.",
    image: "/testimonials/lenas-charm.png",
    imageAlt: "Logo de Lena's Charm, marca de Gisell",
    consent: true,
    proofImage: "/testimonials/proof/gisell-lenascharm.png",
    proofAlt: "Captura de la reseña de Gisell por WhatsApp",
  },
];

export const CLIENT_LOGOS: ClientLogo[] = [
  {
    id: "libertad-con-steph",
    name: "Libertad con Steph",
    logo: "/testimonials/libertad-con-steph.png",
  },
  {
    id: "psicologia-xfavor",
    name: "+Psicología XFavor",
    logo: "/testimonials/psicologia-xfavor.png",
  },
  {
    id: "lenas-charm",
    name: "Lena's Charm",
    logo: "/testimonials/lenas-charm.png",
  },
];

/** Vacío hasta que la clienta entregue fotos de trabajos terminados con marca. */
export const WORK_SAMPLES: WorkSample[] = [];

export const getPublishableTestimonials = (
  items: Testimonial[] = TESTIMONIALS
): Testimonial[] =>
  items.filter(
    (t) =>
      t.consent &&
      t.name.trim() !== "" &&
      t.role.trim() !== "" &&
      t.quote.trim() !== ""
  );
